import React from 'react';
import { createPortal } from 'react-dom';
import { Library, X } from 'lucide-react';
import { useTheme } from '../../../components/common/Theme';

interface CatalogConfirmDialogProps {
  title?: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const CatalogConfirmDialog: React.FC<CatalogConfirmDialogProps> = ({
  title = 'Confirm registration',
  message,
  confirmLabel = 'Register app',
  cancelLabel = 'Cancel',
  danger = false,
  onConfirm,
  onCancel,
}) => {
  const { theme } = useTheme();
  const isLight = theme === 'white';

  return createPortal(
    <div className="fixed inset-0 z-[160] bg-black/60 backdrop-blur-sm flex items-center justify-center p-4">
      <div
        className={`relative w-full max-w-md rounded-xl shadow-2xl border overflow-hidden ${
          isLight ? 'bg-white border-neutral-200' : 'bg-neutral-900 border-neutral-800'
        }`}
      >
        <button
          type="button"
          onClick={onCancel}
          className={`absolute top-3 right-3 p-1.5 rounded-lg transition-colors ${
            isLight ? 'text-neutral-400 hover:text-neutral-900 hover:bg-neutral-100' : 'text-gray-400 hover:text-white hover:bg-neutral-800'
          }`}
          aria-label="Close"
        >
          <X size={16} />
        </button>
        <div className="p-6">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-10 h-10 rounded-xl bg-indigo-600/15 flex items-center justify-center">
              <Library className="text-indigo-400" size={20} />
            </div>
            <h3 className={`text-base font-semibold ${isLight ? 'text-neutral-900' : 'text-white'}`}>{title}</h3>
          </div>
          <p className={`text-sm leading-relaxed mb-6 ${isLight ? 'text-neutral-600' : 'text-gray-400'}`}>{message}</p>
          <div className="flex justify-end gap-2">
            <button
              type="button"
              onClick={onCancel}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                isLight ? 'text-neutral-600 hover:bg-neutral-100' : 'text-gray-300 hover:bg-neutral-800'
              }`}
            >
              {cancelLabel}
            </button>
            <button
              type="button"
              onClick={onConfirm}
              className={`px-4 py-2 rounded-lg text-sm font-medium text-white transition-colors ${
                danger ? 'bg-red-600 hover:bg-red-700' : 'bg-indigo-600 hover:bg-indigo-700'
              }`}
            >
              {confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default CatalogConfirmDialog;
